import React, { useMemo } from 'react'
import PropTypes from 'prop-types/prop-types'
import classNames from 'classnames'
import { useHideToggle } from '../hooks/useHideToggle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { seriesColors } from '../colors'

const LegendItem = (props) => {
  const {
    name,
    styleNames,
    labelStyleNames,
    childIndex,
    hide = false,
    label,
    accessory = 'none',
    accessoryColor,
  } = props

  PropTypes.checkPropTypes(LegendItem.propTypes, props, 'prop', 'LegendItem')

  const hideInternal = useHideToggle(name, hide)

  const attributes = useMemo(() => {
    return {
      ...name && { id: name },
      className: classNames(
        'g-legenditem',
        `child-${childIndex}`,
        { [styleNames]: !!styleNames },
        { hidden: hideInternal }
      )
    }
  }, [hideInternal])

  const iconAttributes = {
    color: accessoryColor || seriesColors[childIndex]
  }

  return (
    <div {...attributes}>
      {accessory === 'bullet' && (
        <div className="g-legenditem-accessory rounded-full flex-shrink-0">
          <FontAwesomeIcon className="g-legenditem-icon" icon="circle" {...iconAttributes} />
        </div>
      )}
      <div className={classNames('g-legenditem-label', labelStyleNames)}>{label}</div>
    </div>
  )
}

LegendItem.propTypes = {
  name: PropTypes.string,
  styleNames: PropTypes.string,
  labelStyleNames: PropTypes.string,
  childIndex: PropTypes.number,
  hide: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  accessory: PropTypes.oneOf(['none', 'bullet']),
  accessoryColor: PropTypes.string,
  children: PropTypes.node,
}

export default LegendItem
